<script setup>
import Banner from 'dashboard/components-next/banner/Banner.vue';

defineProps({
  // What happened to the connection and who must reconnect it.
  message: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['reauthorize']);
</script>

<template>
  <Banner
    color="ruby"
    :action-label="$t('INBOX_MGMT.RECONNECT.BUTTON')"
    @action="emit('reauthorize')"
  >
    {{ message }}
  </Banner>
</template>
